<ion-header>
  <ion-toolbar color="primary">
    <ion-title>{{ 'campus-navi.poi-search.title' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">{{ 'core.done' | translate }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar color="primary">
    <ion-searchbar
      animated
      [(ngModel)]="searchQuery"
      (ionInput)="search()"
      showCancelButton="focus"
      [debounce]="500"
      [cancelButtonText]="'core.cancel' | translate"
      [placeholder]="'campus-navi.searchPlaceholder' | translate"
      (ionClear)="filteredFeatures = null"
      color="light"
    ></ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content>
  @if (features.length === 0 || (filteredFeatures !== null && filteredFeatures.length === 0)) {
    <div class="no-result">
      {{ 'campus-navi.poi-search.noResult' | translate }}
    </div>
  }
  @if (filteredFeatures === null) {
    <ion-list>
      @for (feature of features; track feature) {
        <ion-item (click)="dismiss(feature)">
          @if (feature.properties.category) {
            <ion-icon class="fas {{ feature.properties.category.icon }}" slot="start" size="small"></ion-icon>
          }
          <ion-label>
            <h2>
              {{ feature.properties.name[this.languageCode] }}
            </h2>
            <p>
              {{ feature.properties.category.name[this.languageCode] }}
            </p>
          </ion-label>
        </ion-item>
      }
    </ion-list>
  }
  @if (filteredFeatures !== null) {
    <ion-list>
      @for (feature of filteredFeatures; track feature) {
        <ion-item (click)="dismiss(feature)">
          @if (feature.properties.category) {
            <ion-icon class="fas {{ feature.properties.category.icon }}" slot="start" size="small"></ion-icon>
          }
          <ion-label>
            <h2>
              {{ feature.properties.name[this.languageCode] }}
            </h2>
            <p>
              {{ feature.properties.category.name[this.languageCode] }}
            </p>
          </ion-label>
        </ion-item>
      }
    </ion-list>
  }
</ion-content>
